export default __webpack_public_path__ + "static/media/Neon_Overdrive.dc6ebf14.png";